import { styled } from "@mui/material";

export const Iframe = styled("iframe")`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
`;

export const IFrameContainer = styled("div")`
	padding-top: 56.25%;
	width: 100%;
	position: relative;
`;
